import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getSubscriptionFlowApiClient } from "@shared/apis/sidekick/api-factories";
import { GET_SUBSCRIPTION_FLOW_QUERY_KEY } from "./useGetSubscriptionFlow";
import { toast } from "@shared/services/toast";

type Props = {
  onSuccess?: () => void;
};

type Params = {
  subscriptionId: string;
  token: string;
};

export const useConfirmChangeSubscriptionEmail = (props?: Props) => {
  const { onSuccess } = props || {};
  const api = getSubscriptionFlowApiClient();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async (params: Params) => {
      const response =
        await api.subscriptionFlowControllerConfirmEmailReplacement({
          id: params.subscriptionId,
          confirmEmailReplacementRequestOmitted: {
            token: params.token,
          },
        });
      queryClient.invalidateQueries({
        queryKey: [GET_SUBSCRIPTION_FLOW_QUERY_KEY],
      });
      toast.success("Email confirmed successfully");
      onSuccess?.();
      return response;
    },
    onError: (error) => {
      console.error(
        `Failed to confirm email change in the subscription flow`,
        error
      );
      toast.error(
        "Invalid token. The token you entered is incorrect. Please check the 6-digit token sent to your email and try again. If you did not receive the email, check your spam or junk folder, or request a new token.",
        {
          autoClose: false,
        }
      );
    },
  });

  return mutation;
};
